module.exports = __webpack_public_path__ + "static/media/aa-min.67c1f6f7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/min/aa-min.svg
// module id = 679
// module chunks = 0